export const BASE_URL = {
  USERS: import.meta.env.VITE_USER_API_URL,
  RENTALS: import.meta.env.VITE_RENTALS_API_URL,
  ELASTIC: import.meta.env.VITE_WEB_RENTAL_ELASTIC,
  MAPS: import.meta.env.VITE_MAPS_API_URL,
  ORGANIZATIONS: import.meta.env.VITE_RENTALS_API_ORGANIZATIONS_URL,
  NOTIFICATIONS: import.meta.env.VITE_NOTIFICATIONS_API_URL,
  DOCUMENT_SIGNING: import.meta.env.VITE_DOCUMENT_SIGNING_URL,
  WEBFLOW: import.meta.env.VITE_WEBFLOW_API_URL,
  WEB_URL: import.meta.env.VITE_WEB_URL,
  SENTRY_URL: import.meta.env.VITE_SENTRY_URL,
  SENTRY_ENV: import.meta.env.SENTRY_ENV,
  CHAT: import.meta.env.VITE_CHAT_API_URL,
  TIQETS_PROXY_URL: import.meta.env.VITE_TIQETS_PROXY_URL
};
